import { getDataFromStorage } from "../libs/auth.helper";
export const getOtherUserId = (chat) => {
    const currentUserId = getUserInfo().id;
    return chat.rooms[0].uid === parseInt(currentUserId) ? chat.oid : chat.rooms[0].uid;
};
export const getUserInfo = () => {
    return getDataFromStorage().userInfo;
};
export const isSender = (message) => {
    return message.sender_id === getUserInfo().id;
};
